import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/github.svg'
import _imports_1 from '@/assets/images/twitter.svg'
import _imports_2 from '@/assets/images/hatenablog.svg'
import _imports_3 from '@/assets/images/qiita.svg'


const _hoisted_1 = { id: "global_footer" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<ul class=\"footer_banner_link\"><li><a href=\"https://github.com/muak\" class=\"github\"><img src=\"" + _imports_0 + "\" alt=\"GitHub\"></a></li><li><a href=\"https://twitter.com/muak_x\" class=\"twitter\"><img src=\"" + _imports_1 + "\" alt=\"Twitter\"></a></li><li><a href=\"https://kamusoft.hatenablog.jp/\" class=\"hatenablog\"><img src=\"" + _imports_2 + "\" alt=\"はてなブログ\"></a></li><li><a href=\"https://qiita.com/muak_x\" class=\"qiita\"><img src=\"" + _imports_3 + "\" alt=\"Qiita\"></a></li></ul><ul class=\"footer_text_link\"><li><a href=\"https://itunes.apple.com/jp/developer/satoshi-nakamura/id1160206847\">AppStore開発者ページ</a></li><li><a href=\"https://play.google.com/store/apps/developer?id=kamusoft\">GooglePlay開発者ページ</a></li><li><a href=\"https://www.nuget.org/profiles/kamu\">nugetプロフィール</a></li></ul>", 2)
const _hoisted_4 = { class: "footer_bottom" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("nav", null, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("li", null, "© " + _toDisplayString(_ctx.Year) + " kamusoft", 1)
      ])
    ])
  ]))
}